import json from './sprite.js';

export default {
    handle: 'SP_SPS2-FavoriteToy',
    label: 'es_SPS2-FavoriteToy_234684029',
    json,
};
